// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collapsibleMenuComponent {
  position: relative;
  color: #505054;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
}
.collapsibleMenuComponent .titleContainer {
  height: 48px !important;
  margin-top: 13.5px;
  margin-top: 2px;
  margin-bottom: -10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 13px 18px;
  border-radius: 8px;
}
.collapsibleMenuComponent .titleImage {
  height: 24px;
  width: 24px;
  display: inline-block;
  position: relative;
  bottom: 2px;
  left: 3px;
}
.collapsibleMenuComponent .titleText {
  display: inline-block;
  position: relative;
  left: 7px;
  bottom: 5px;
  font-size: 16px;
  font-weight: 500;
  font-family: "Spoqa Han Sans Neo";
}
.collapsibleMenuComponent .titleTextAndImage {
  display: inline-block;
  position: relative;
}
.collapsibleMenuComponent .titleIcon {
  display: inline-block;
  position: relative;
  height: 24px;
  width: 24px;
  transform: rotate(180deg);
  transition: transform 0.25s;
}
.collapsibleMenuComponent .rotatedTitleIcon {
  display: inline-block;
  position: relative;
  height: 24px;
  width: 24px;
  transition: transform 0.25s;
}
.collapsibleMenuComponent .menuItemRowContainer {
  padding: 6px;
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  cursor: pointer;
}
.collapsibleMenuComponent .menuItemRowContainer a:visited {
  text-decoration: none;
  color: #353d47;
}
.collapsibleMenuComponent .menuItemRowContainer .menuItemRow {
  margin-top: 2px;
  padding: 13px 18px 13px 50px;
  height: 48px;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/sideNavBar/CollapsibleMenu/CollapsibleMenu.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,cAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AACJ;AAAI;EACI,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AAER;AACI;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AACR;AAEI;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAAR;AAGI;EACI,qBAAA;EACA,kBAAA;AADR;AAII;EACI,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,2BAAA;AAFR;AAKI;EACI,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,2BAAA;AAHR;AAMI;EACI,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,eAAA;AAJR;AAMQ;EACI,qBAAA;EACA,cAAA;AAJZ;AAOQ;EACI,eAAA;EACA,4BAAA;EACA,YAAA;EACA,kBAAA;AALZ","sourcesContent":[".collapsibleMenuComponent {\n    position: relative;\n    color: #505054;\n    font-family: 'Spoqa Han Sans Neo';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 22px; \n    .titleContainer {\n        height: 48px!important ;\n        margin-top: 13.5px;\n        margin-top: 2px;\n        margin-bottom: -10px;\n        cursor: pointer;\n        display: flex;\n        justify-content: space-between;\n        padding: 13px 18px;\n        border-radius: 8px;\n    }\n\n    .titleImage {\n        height: 24px;\n        width: 24px;\n        display: inline-block;\n        position: relative;\n        bottom: 2px;\n        left: 3px;\n    }\n\n    .titleText {\n        display: inline-block;\n        position: relative;\n        left: 7px;\n        bottom: 5px;\n        font-size: 16px;\n        font-weight: 500;\n        font-family: 'Spoqa Han Sans Neo';\n    }\n\n    .titleTextAndImage {\n        display: inline-block;\n        position: relative;\n    }\n\n    .titleIcon {\n        display: inline-block;\n        position: relative;\n        height: 24px;\n        width: 24px;\n        transform: rotate(180deg);\n        transition: transform 0.25s;\n    }\n\n    .rotatedTitleIcon {\n        display: inline-block;\n        position: relative;\n        height: 24px;\n        width: 24px;\n        transition: transform 0.25s;\n    }\n\n    .menuItemRowContainer {\n        padding: 6px;\n        margin-bottom: 0px !important;\n        padding-bottom: 0px !important; \n        cursor: pointer;\n\n        a:visited {\n            text-decoration: none;\n            color: #353d47;\n        }\n\n        .menuItemRow {\n            margin-top: 2px;\n            padding: 13px 18px 13px 50px;\n            height: 48px; \n            border-radius: 8px;\n        }\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
